import { dateTimeFormatFr } from '@/utils/data/date'
import { userName } from '@/utils/data/agents'

export const DEMANDES_STATUS_PENDING = 100
export const DEMANDES_STATUS_ACCEPTED = 200
export const DEMANDES_STATUS_REFUSED = 300
export const DEMANDES_STATUS_REPORTED = 400

export const DEMANDES_STATUS_LIST = [
  {
    value: DEMANDES_STATUS_PENDING,
    label: 'En attente',
    color: 'warning'
  },
  {
    value: DEMANDES_STATUS_ACCEPTED,
    label: 'Accepté',
    color: 'positive'
  },
  {
    value: DEMANDES_STATUS_REFUSED,
    label: 'Refusé',
    color: 'negative'
  },
  {
    value: DEMANDES_STATUS_REPORTED,
    label: 'Reporté',
    color: 'accent'
  }
]

export const DEMANDES_STATUS = _.keyBy(DEMANDES_STATUS_LIST, 'value')

export const DATA_DEMANDES_PERSISTANCE_KEY = 'Demandes'
export const DATA_DEMANDES_COLUMNS = [
  {
    name: 'createdAt',
    field: 'createdAt',
    label: 'Date',
    sortable: true,
    format: (v) => dateTimeFormatFr(v),
    classes: 'sticky',
    headerClasses: 'sticky'
  },
  {
    name: 'agent',
    label: 'Agent',
    field: 'agent',
    format: (v) => userName(v)
  },
  {
    name: 'type',
    field: 'requestType',
    label: 'Type',
    format: (val = {}) => val.name
  },
  {
    name: 'status',
    field: 'status',
    label: `Status`,
    sortable: true
  },
  {
    name: 'attachments',
    field: 'attachments.length',
    label: 'Pièces jointes'
  }
]

export const DATA_DEMANDES_INDEXED_COLUMNS = _.keyBy(DATA_DEMANDES_COLUMNS, 'name')
